module.exports = __webpack_public_path__ + "img/goods10_6.c0d477ab.jpg";